import { Box } from '@chakra-ui/core';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import WalletPasswordSetup from '../../containers/Wallet/WalletPasswordSetup';
import Header from '../Header';
import RestoreSeed from './RestoreSeed';

const heights = [220, 350, 415, 310, 150, 250, 290, 185, 230, 230, 250];
heights[98] = 130;

const SignIn = () => {
  const [step, setStep] = useState(1);

  const history = useHistory();

  return (
    <Box>
      <Header h="10rem" borderRadius="0 0 2px 2px" />

      <Box
        my="6rem"
        width="45em"
        mx="auto"
        boxShadow="0px 0px 14px 3px rgba(0, 0, 0, 0.07)"
        borderRadius="4px"
        p="2rem"
        backgroundColor="white"
        h="fit-content"
      >
        {(function () {
          switch (step) {
            case 1:
              return <RestoreSeed setStep={setStep} />;
            case 2:
              return (
                <WalletPasswordSetup
                  onBack={() => setStep(1)}
                  onNext={() => history.push('/dashboard')}
                />
              );

            default:
              return <p>Error</p>;
          }
        })()}
      </Box>
    </Box>
  );
};

export default SignIn;
